import { useMeQuery } from '@/src/features/auth/services/useMeQuery'

const PAPA_QUIZ_START_DAY = 15
const PAPA_QUIZ_END_DAY = 29
const PAPA_QUIZ_MONTH = 8

export const isPapaStyleActive = (date: Date): boolean =>
  date.getMonth() === PAPA_QUIZ_MONTH && date.getDate() >= PAPA_QUIZ_START_DAY && date.getDate() <= PAPA_QUIZ_END_DAY

export const usePapaStyle = (date?: Date) => {
  const { data: me } = useMeQuery()
  const showPapaStyle =
    isPapaStyleActive(date ?? new Date()) && me?.lang === 'fr' && me.countryCode?.toLowerCase() === 'fr'
  return { showPapaStyle }
}
